import request from '@utils/request'

export function postDeliveryList(data) {
    return request({
        url: '/service/mg/delivery-management/delivery-list',
        method: 'POST',
        data,
    })
}

export function postDeliveryListInfo(data) {
    return request({
        url: '/service/mg/delivery-management/delivery-list-info',
        method: 'POST',
        data,
    })
}

export function postBatchDelivery(data) {
    return request({
        url: '/service/mg/delivery-management/batch-delivery',
        method: 'POST',
        data,
    })
}

export function downloadDeliverOrder(data) {
    return request({
        url: '/service/dubbo/proxy/abd/download-deliver-order',
        method: 'POST',
        data,
    })
}
